module.exports = __webpack_public_path__ + "img/banner_c1.d5db4a35.jpg";